import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/subscriptions")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Subscriptions</div>
        <div className="page-subtitle">Manage billing and subscriptions</div>
      </div>
    </>
  ),
});
